const SUPABASE_URL = 'sb_publishable_ihes1NUcyvuSWJMKA3zewQ_xSxnPo3d';
const SUPABASE_KEY = 'sb_publishable_ihes1NUcyvuSWJMKA3zewQ_xSxnPo3d';

async function fetchLikeCounts() {
  try {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/post_like_counts?select=*`, {
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`
      }
    });
    const data = await res.json();
    data.forEach(row => {
      const countEl = document.querySelector(`[data-post-id="${row.post_id}"] .like-count`);
      if (countEl) countEl.textContent = row.like_count;
    });
  } catch(e) {
    console.log('Like fetch error:', e);
  }
}

async function toggleLike(postId) {
  const btn = document.querySelector(`[data-post-id="${postId}"] .like-btn`);
  const likedPosts = JSON.parse(localStorage.getItem('liked_posts') || '[]');
  const alreadyLiked = likedPosts.includes(postId);

  btn.disabled = true;

  if (alreadyLiked) {
    await fetch(`${SUPABASE_URL}/rest/v1/post_likes?post_id=eq.${postId}`, {
      method: 'DELETE',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`
      }
    });
    localStorage.setItem('liked_posts', JSON.stringify(likedPosts.filter(id => id !== postId)));
    btn.classList.remove('liked');
  } else {
    await fetch(`${SUPABASE_URL}/rest/v1/post_likes`, {
      method: 'POST',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ post_id: postId })
    });
    likedPosts.push(postId);
    localStorage.setItem('liked_posts', JSON.stringify(likedPosts));
    btn.classList.add('liked');
  }

  btn.disabled = false;
  fetchLikeCounts();
}

document.addEventListener('DOMContentLoaded', () => {
  const likedPosts = JSON.parse(localStorage.getItem('liked_posts') || '[]');
  likedPosts.forEach(postId => {
    const btn = document.querySelector(`[data-post-id="${postId}"] .like-btn`);
    if (btn) btn.classList.add('liked');
  });
  fetchLikeCounts();
});